// extracted by mini-css-extract-plugin
export default {"section":"chartsPage_section__5ghca"};